import { render, staticRenderFns } from "./GoodsAttr.vue?vue&type=template&id=f682f644&scoped=true"
import script from "./GoodsAttr.vue?vue&type=script&lang=js"
export * from "./GoodsAttr.vue?vue&type=script&lang=js"
import style0 from "./GoodsAttr.vue?vue&type=style&index=0&id=f682f644&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f682f644",
  null
  
)

export default component.exports